import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { GetConnectionsCount } from "src/services/organizations/queries/NetTypes";

import { useGetApp } from "../../AppSettings/Details/hook/useGetApp";
import Context from "../context";

export type EntityData = {
	entity: string;
	count: number;
	countReady: number;
	countFailure: number;
};

export default function useGetEntitiesData(comparator: (a: any, b: any) => number) {
	const { product } = useContext(Context);

	const app = useGetApp();

	const { data } = useQuery<GetConnectionsCount>({
		queryKey: [app?.id, product ? `${product}Count` : "allCount"],
		initialData: { variation: { mtd: 0, ytd: 0, day: 0 }, current: [] }
	});

	let resultByEntity = data.current
		.filter((i) => i.status === "ERRORED" || i.status === "READY")
		.reduce((acc, curr) => {
			const entity = curr.entity;
			const status = curr.status;

			const existing = acc.find((item) => item.entity === entity);

			if (existing) {
				existing.count += curr.count;

				if (status === "READY") {
					existing.countReady += curr.count;
				} else if (status === "ERRORED") {
					existing.countFailure += curr.count;
				}
			} else {
				acc.push({
					entity,
					count: curr.count,
					countReady: status === "READY" ? curr.count : 0,
					countFailure: status === "ERRORED" ? curr.count : 0
				});
			}

			return acc;
		}, [] as EntityData[]);

	const stabilizedThis = resultByEntity.map((el, index) => [el, index] as const);

	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	});

	resultByEntity = stabilizedThis.map((el) => el[0]);

	return resultByEntity;
}
